import { UseInfiniteQueryResult } from '@tanstack/react-query';
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroller';

import { Loading, Typography } from '@/shared/components/atoms';
import { IGeneral } from '@/shared/types';

interface IGetSuggestedListResponse
  extends IGeneral.IPaginationSchema,
    IGeneral.IInfiniteQuery {
  items: { name: string; alreadyExists: IGeneral.IBinary }[];
  totalCount: number;
}

const SuggestionsList: React.FC<{
  requestInfo: UseInfiniteQueryResult<IGetSuggestedListResponse, unknown>;
  setNameValue: (name: string) => void;
  placeholder: string;
  divRef: React.RefObject<HTMLDivElement>;
}> = ({ setNameValue, divRef, requestInfo, placeholder }) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const { data, hasNextPage, fetchNextPage } = requestInfo;

  const closeDropdownHandler = () => {
    setIsOpen(false);
  };

  const closeOpenMenus = useCallback(
    (e: MouseEvent) => {
      if (divRef.current && divRef.current.contains(e.target as Node)) {
        setIsOpen(true);
      } else closeDropdownHandler();
    },
    [divRef]
  );

  useEffect(() => {
    document.addEventListener('mousedown', closeOpenMenus);

    return () => {
      document.removeEventListener('mousedown', closeOpenMenus);
    };
  }, [divRef, closeOpenMenus]);

  if (
    !data ||
    (data && data.pages?.length > 0 && data?.pages[0].items?.length === 0) ||
    !isOpen
  )
    return <></>;

  return (
    <InfiniteScroll
      loadMore={() => fetchNextPage()}
      hasMore={hasNextPage}
      loader={<Loading />}
      useWindow={false}
      className='absolute top-full left-0 z-10 flex max-h-125 w-full min-w-full max-w-fit flex-col gap-16 overflow-hidden overflow-y-scroll rounded-xl bg-neutralVariant-99 p-16'
    >
      <Typography
        className='px-8 text-surface-10'
        weight='medium'
        variant='caption'
      >
        {placeholder}
      </Typography>
      {data?.pages?.map((page, i) => (
        <Fragment key={i}>
          {page?.items?.map((item) => (
            <div
              key={item.name}
              className='cursor-pointer p-2 hover:text-primary-default'
              onClick={() => {
                setNameValue(item.name);
                closeDropdownHandler();
              }}
            >
              {item.name}
            </div>
          ))}
        </Fragment>
      ))}
    </InfiniteScroll>
  );
};

export { SuggestionsList };
